"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as n, jsxs as A } from "react/jsx-runtime";
import * as i from "react";
import { UP as B, LEFT as q, DOWN as E, RIGHT as T, SPACE as w } from "./utils/keys.js";
import { useControlProps as G } from "./form-context.js";
import { combineRefs as O } from "./utils/common.js";
import { Text3 as k } from "./text.js";
import j from "./inline.js";
import P from "classnames";
import { useTheme as F } from "./hooks.js";
import { getPrefixedDataAttributes as N } from "./utils/dom.js";
import { outerCircleVariants as I, outerCircleCheckedVariants as K, disabled as D, innerCircle as $, innerCircleChecked as H, radioButtonContainerDisabled as U, radioButton as W } from "./radio-button.css-mistica.js";
const S = /*#__PURE__*/ i.createContext({
    disabled: !1,
    selectedValue: null,
    focusableValue: null,
    select: ()=>{},
    selectNext: ()=>{},
    selectPrev: ()=>{}
}), z = ()=>i.useContext(S), J = (_param)=>{
    var { value: e, id: s, dataAttributes: h, "aria-labelledby": g, "aria-label": x } = _param, f = _object_without_properties(_param, [
        "value",
        "id",
        "dataAttributes",
        "aria-labelledby",
        "aria-label"
    ]);
    const { disabled: l, selectedValue: v, focusableValue: C, select: c, selectNext: p, selectPrev: y } = z(), r = i.useId(), b = g || r, V = i.useRef(null), d = e === v, o = C === e ? 0 : -1, { isIos: t } = F(), R = (a)=>{
        switch(a.key){
            case w:
                c(e), a.preventDefault(), a.stopPropagation();
                break;
            case T:
            case E:
                p(), a.preventDefault(), a.stopPropagation();
                break;
            case q:
            case B:
                y(), a.preventDefault(), a.stopPropagation();
                break;
        }
    }, u = /* @__PURE__ */ n("div", {
        className: P(t ? I.ios : I.default, {
            [K[t ? "ios" : "default"]]: d,
            [D]: l
        }),
        children: !t && /* @__PURE__ */ n("div", {
            className: P($, {
                [H]: d
            })
        })
    });
    return(// eslint-disable-next-line jsx-a11y/interactive-supports-focus
    /* @__PURE__ */ n("span", _object_spread_props(_object_spread({
        ref: V,
        id: s,
        tabIndex: l ? void 0 : o,
        role: "radio",
        "data-value": e,
        "aria-checked": d,
        "aria-disabled": l,
        "aria-label": x,
        "aria-labelledby": x ? void 0 : b,
        onClick: (a)=>{
            a.stopPropagation(), l || c(e);
        },
        onKeyDown: l ? void 0 : R,
        className: l ? U : W
    }, N(h, "RadioButton")), {
        children: f.render ? f.render({
            controlElement: u,
            disabled: !!l,
            checked: d,
            labelId: b
        }) : /* @__PURE__ */ A(j, {
            space: 16,
            children: [
                /* @__PURE__ */ n(k, {
                    regular: !0,
                    as: "div",
                    children: /* @__PURE__ */ n("div", {
                        style: {
                            position: "relative",
                            top: -2
                        },
                        children: u
                    })
                }),
                /* @__PURE__ */ n(k, {
                    regular: !0,
                    as: "div",
                    id: b,
                    children: /* @__PURE__ */ n("span", {
                        className: l ? D : "",
                        children: f.children
                    })
                })
            ]
        })
    })));
}, oe = (e)=>{
    var _ref;
    const { value: s, defaultValue: h, onChange: g, focusableRef: x, disabled: f } = G({
        name: e.name,
        value: e.value,
        defaultValue: e.defaultValue,
        onChange: e.onChange,
        disabled: e.disabled
    }), l = typeof s < "u", [v, C] = i.useState((_ref = s !== null && s !== void 0 ? s : h) !== null && _ref !== void 0 ? _ref : "");
    i.useEffect(()=>{
        s !== void 0 && C(s);
    }, [
        s
    ]);
    const c = (o)=>{
        l || C(o), g(o);
    }, [p, y] = i.useState(null), r = i.useRef(null), b = ()=>{
        if (r.current) {
            const o = r.current.querySelector("[role=radio][aria-checked=true]"), t = Array.from(r.current.querySelectorAll("[role=radio]"));
            if (t.length === 0) return;
            const u = ((o ? t.indexOf(o) : 0) + 1) % t.length, a = t[u], m = a.dataset.value;
            m && (a.focus(), c(m));
        }
    }, V = ()=>{
        if (r.current) {
            const o = r.current.querySelector("[role=radio][aria-checked=true]"), t = Array.from(r.current.querySelectorAll("[role=radio]"));
            if (t.length === 0) return;
            const R = o ? t.indexOf(o) : 0, u = (t.length + R - 1) % t.length, a = t[u], m = a.dataset.value;
            m && (a.focus(), c(m));
        }
    };
    i.useEffect(()=>{
        if (r.current) {
            const o = r.current.querySelector("[role=radio]");
            var _o_dataset_value;
            o && y((_o_dataset_value = o.dataset.value) !== null && _o_dataset_value !== void 0 ? _o_dataset_value : null);
        }
    }, []);
    var _ref1;
    const d = (_ref1 = v !== null && v !== void 0 ? v : p) !== null && _ref1 !== void 0 ? _ref1 : null;
    return /* @__PURE__ */ n("div", _object_spread_props(_object_spread({
        ref: O(r, x),
        role: "radiogroup",
        "aria-label": e["aria-label"],
        "aria-labelledby": e["aria-label"] ? void 0 : e["aria-labelledby"]
    }, N(e.dataAttributes, "RadioGroup")), {
        children: /* @__PURE__ */ n(S.Provider, {
            value: {
                disabled: f,
                selectedValue: v !== null && v !== void 0 ? v : h,
                focusableValue: d,
                select: c,
                selectNext: b,
                selectPrev: V
            },
            children: e.children
        })
    }));
}, re = J;
export { oe as RadioGroup, re as default, z as useRadioContext };
